import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/core/alert.service';
import { ToastService } from 'src/app/core/toast.service';
import { ApiGruposopcionaisService } from 'src/app/dao/api-gruposopcionais.service';
import { ProdutoapiService } from 'src/app/dao/api_produto.service';
import { GlobalService } from 'src/app/dao/global.service';
import { GruposOpcional } from 'src/app/model/gruposopcionais';

@Component({
  selector: 'app-opcgrupo-list',
  templateUrl: './opcgrupo-list.page.html',
  styleUrls: ['./opcgrupo-list.page.scss'],
})
export class OpcgrupoListPage implements OnInit {
  // tslint:disable-next-line: no-inferrable-types
  showSearch: boolean = false;
  produtos: GruposOpcional[] = [];
  prod: GruposOpcional;
  inicio = '';
  fim = '';
  user: string;
  pass: string;
  idCategoria;

  categoriasNomesAux = [];
  
  
  constructor(private route: ActivatedRoute,
              private toast: ToastService,
              private alert: AlertService,
              private apiproduto: ApiGruposopcionaisService,
              private global: GlobalService,
              private apiOpcs: ApiGruposopcionaisService) { }
  
  
  
  async ngOnInit() {
   this.user = this.global.user;
   this.pass = this.global.pass;
  
   const idParam = this.route.snapshot.paramMap.get('id');
   if (idParam) {
     // tslint:disable-next-line: radix
     this.idCategoria = idParam;

     


     this.categoriasNomesAux =  await this.apiOpcs.listarTodosNomes()
     .catch(err => {
      console.error('Erro ao obter Opcionais', err);
      this.toast.showError('Erro ao obter Opcionais');
    });
    
    const encontrada = this.categoriasNomesAux.find(item => item.grupo === this.idCategoria);
    
    if (encontrada) {
      this.idCategoria = encontrada.nome;
    }
    

     // tslint:disable-next-line: radix
     this.loadProd(idParam);
   }
  }
  
  ionViewWillEnter() {
    this.user = this.global.user;
    this.pass = this.global.pass;
  }
  
  async loadProd(idCat) {
    this.apiproduto.getByGrupo(idCat).then(res => {
      this.produtos = res;
      //this.toast.showSucess('Produtos obtidos com sucesso!');
    }).catch(async err => {
      console.log('err', err);
      this.toast.showError('Erro ao obter Opcionais');
    });
  }
  searchButtonClick() {
    this.showSearch = true;
  }

  


  
  mudastts(prod: GruposOpcional) {
  const novoStatus = !prod.ativo;
  prod.ativo = novoStatus;
  this.apiproduto.atualizarstts(prod)
     .then(() => {
       const acao = novoStatus ? 'ativado' : 'desativado';
       prod.ativo = novoStatus;
       this.toast.showSucess(`Opcional ${acao} com sucesso!`);
     })
     .catch(erro => {
       console.log(erro);
       this.toast.showError('Erro ao Alterar Status');
     });
  
  }
  
  }

  


